// Step3Category.tsx
import React from 'react';

interface Step2CategoryProps {
  category: string;
  setCategory: (category: string) => void;
  errors: { [key: string]: string };
}

const Step3Category: React.FC<Step2CategoryProps> = ({
                                                       category,
                                                       setCategory,
                                                       errors,
                                                     }) => {
  return (
    <div className="w-full">
      {/* 카테고리 */}
      <div className="mb-4">
        <label htmlFor="category" className="block font-medium mb-1">
          카테고리 <span className="text-red-500">*</span>
        </label>
        <p className="text-gray-500 text-sm mb-2">
          상품의 카테고리를 선택해주세요.
        </p>
        <select
          id="category"
          className={`border p-2 w-full rounded ${
            errors.category ? "border-red-500" : "border-gray-300"
          }`}
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="">카테고리를 선택하세요</option>
          <option value="모델링">모델링</option>
          <option value="건축">건축</option>
          <option value="엔티티">엔티티</option>
          <option value="픽셀">픽셀</option>
          <option value="무료">무료</option>
          <option value="스크립트">스크립트</option>
          <option value="스킨">스킨</option>
          <option value="스킬">스킬</option>
          <option value="플러그인">플러그인</option>
        </select>
        {errors.category && (
          <p className="text-red-500 text-sm mt-1">{errors.category}</p>
        )}
      </div>
    </div>
  );
};

export default Step3Category;
